
import React, { Component } from 'react'
import { Row, Col, Modal, Input, Select, DatePicker, Spin, message } from 'antd'
import $ from 'jquery';

const { TextArea } = Input;
const Option = Select.Option;
const { RangePicker } = DatePicker;

class NewLeaveA extends Component {

    constructor( props ){
        super( props );

        this.state = {
            employee_list: [],
            leavetype_list: [],
            visible: false,
            loader: false,
            user_id: '',
            leave_id: '',
            start_date: '',
            end_date: '',
            reason: '',
            attachment: '',
            unit: 1
        }

        this.handleOk = this.handleOk.bind( this );
        this.handleCancel = this.handleCancel.bind( this );
        this.handleAttachment = this.handleAttachment.bind( this );

    }

    componentWillReceiveProps( nextProps ){

        this.setState({ 
            visible: nextProps.onVisible,
            loader: nextProps.onLoader,
            attachment: nextProps.onAttachment,
            employee_list: nextProps.employeelist,
            leavetype_list: nextProps.leavetypelist,
        });

    }

    handleOk(){

        let data = {
            user_id: this.state.user_id,
            leave_id: this.state.leave_id,
            start_date: this.state.start_date,
            end_date: this.state.end_date,
            reason: this.state.reason,
            attachment: this.state.attachment,
            unit: this.state.unit
        }


        if( this.state.user_id === "" ||
            this.state.leave_id === "" ||
            this.state.start_date === "" ||
            this.state.end_date === "" ){

            return false;

        }

        this.props.onSubmit( data );
    
    }

    handleCancel(){
        this.props.onCancel( false );
    }

    handleAttachment( e ){
        var fdata = new FormData();
        // let user = getCookie('dv_hrms_user').split(',');
        // var user_id =  user[1];

        this.setState({ loader: true });

        if( e.target.files.length>0 ){
            $.each( e.target.files, function( i, file ){

                if( file.size >= 524288000 ){
                    message.error( "File Size too Big", "error" );
                    return false;
                }
                
                fdata.append( "file"+[i], file );
                // fdata.append( "user_id", user_id );

            });
        }

        this.props.onUpload( fdata );
    }

    render() {

        const employee_list = this.state.employee_list.map( (item, i ) => <Option key={ item.user_id } >{ item.full_name }</Option> )

        const leavetype_list = this.state.leavetype_list.map( (item, i ) => <Option key={ item.leave_type_id }>{ item.leave_type_name}</Option> )

        return (
            <Modal
                title="Add New Leave"
                maskClosable={ false }
                visible={ this.state.visible }
                onOk={ this.handleOk }
                onCancel={ this.handleCancel }>

                <Row gutter={16} className="mrg_b_10">
                    <Col span={ 12 }>
                        <label>Employee</label>
                        <Select
                            showSearch
                            onChange={ ( value ) => this.setState({ user_id: value }) } 
                            placeholder="Select User"
                            filterOption={(input, option) =>
                                option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                            }
                            style={{ width: '100%' }}>
                            { employee_list }
                        </Select>
                    </Col>
                    <Col span={ 12 }>
                        <label>Unit</label>
                        <br />
                        <Select
                            value={ this.state.unit }
                            onChange={ (value)=>this.setState({ unit: value }) }
                            style={{ width: '100%' }}>
                            <Option value={ 1 }>Full Day</Option>
                            <Option value={ 0.5 }>Half Day</Option>
                        </Select>
                    </Col>
                </Row>

                <Row gutter={16} className="mrg_b_10">
                    <Col span={ 12 }>
                        <label>Leave Type</label>
                        <br />
                        <Select 
                            onChange={ ( value ) => this.setState({ leave_id: value }) } 
                            placeholder="Select Leave Type"
                            style={{ width: '100%' }}>
                            { leavetype_list }
                        </Select>
                    </Col>
                    <Col span={ 12 }>
                        <label>From - To Date</label>
                        <br />
                        { ( this.state.unit === 1 ) ? 
                            <RangePicker onChange={ ( date, dateString ) =>  this.setState({ start_date: dateString[0], end_date: dateString[1] }) } style={{ width: '100%' }} /> : 
                            <DatePicker onChange={ ( date, dateString ) =>  this.setState({ start_date: dateString, end_date: dateString }) } style={{ width: '100%' }} /> }
                    </Col>
                </Row>

                <Row className="mrg_b_10">
                    <Col span={ 24 }>
                        <label>Reason for leave</label>
                        <TextArea onChange={ ( e ) => this.setState({ reason: e.target.value }) } row={3} />
                    </Col>
                </Row>

                <Row className="mrg_b_10">
                    <Col span={ 24 }>
                        <label>Attachment ( <em styel={{ fontSize: '8px', color: '#999' }}>If you have multiple files please zip and attach</em> )</label>
                        <Spin spinning={ this.state.loader }>
                            <input type="file" className={ ( this.state.attachment ) ? 'success': 'error' } onChange={ this.handleAttachment } />
                        </Spin>
                    </Col>
                </Row>

            </Modal>
        )
    }
}

export default NewLeaveA


// WEBPACK FOOTER //
// ./src/pages/leaves_admin/childs/new.leave.js